import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`container box-border mx-auto p-6`}
  ${tw`lg:flex lg:gap-8`}
`;

// Left Column
const LeftColumn = styled.div`
  ${tw`w-full lg:w-1/3`}
`;

const CarPreview = styled.div`
  ${tw`mb-6 w-full max-w-full min-w-0 box-border`}
`;

const CarImageSkeleton = styled(Skeleton)`
  ${tw`w-full h-48 rounded-lg mb-4 relative`}
`;

const DealerInfoContainer = styled.div`
  ${tw`mb-6`}
`;

const DealerNameSkeleton = styled(Skeleton)`
  ${tw`h-7 w-48 mb-2`}
`;

const DealerDetailsSkeleton = styled(Skeleton)`
  ${tw`h-4 w-64 mb-2`}
`;

const NavigationList = styled.nav`
  ${tw`space-y-2`}
`;

const NavItemSkeleton = styled(Skeleton)`
  ${tw`h-12 w-full rounded-lg mb-2`}
`;

// Right Column
const RightColumn = styled.div`
  ${tw`hidden lg:block lg:w-2/3`}
`;

const ContentSkeleton = styled.div`
  ${tw`flex flex-col`}
`;

const SectionTitleSkeleton = styled(Skeleton)`
  ${tw`h-8 w-48 mb-4`}
`;

const FormGroupSkeleton = styled.div`
  ${tw`mb-6`}
`;

const FormLabelSkeleton = styled(Skeleton)`
  ${tw`h-5 w-24 mb-2`}
`;

const FormInputSkeleton = styled(Skeleton)`
  ${tw`h-11 w-full rounded`}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`h-12 w-40 mt-6 rounded`}
`;

const DealerPageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <LeftColumn>
        <CarPreview>
          <CarImageSkeleton />
          <DealerInfoContainer>
            <DealerNameSkeleton />
            <DealerDetailsSkeleton />
            <DealerDetailsSkeleton width="80%" />
          </DealerInfoContainer>
        </CarPreview>

        <NavigationList>
          <NavItemSkeleton />
          <NavItemSkeleton />
          <NavItemSkeleton />
        </NavigationList>
      </LeftColumn>

      <RightColumn>
        <ContentSkeleton>
          <SectionTitleSkeleton />
          <FormGroupSkeleton>
            <FormLabelSkeleton />
            <FormInputSkeleton />
          </FormGroupSkeleton>

          <FormGroupSkeleton>
            <FormLabelSkeleton />
            <FormInputSkeleton />
          </FormGroupSkeleton>

          <FormGroupSkeleton>
            <FormLabelSkeleton />
            <FormInputSkeleton />
          </FormGroupSkeleton>

          <FormGroupSkeleton>
            <FormLabelSkeleton />
            <FormInputSkeleton />
          </FormGroupSkeleton>

          <ButtonSkeleton />
        </ContentSkeleton>
      </RightColumn>
    </PageContainer>
  );
};

export default DealerPageSkeleton;
